/* Fonts, self-hosted. No third-party request on a page a buyer opens from a
   WhatsApp forward on a metered connection. Arabic subsets first; the Latin
   subsets carry the numerals and the occasional Latin run inside Arabic text
   («مطبخ أمريكي» beside «POLYETHYLENE»), and both come from the same family so
   the bidi runs cannot disagree about metrics. */
import '@fontsource/almarai/arabic-800.css';
import '@fontsource/almarai/latin-800.css';
import '@fontsource/ibm-plex-sans-arabic/arabic-400.css';
import '@fontsource/ibm-plex-sans-arabic/arabic-600.css';
import '@fontsource/ibm-plex-sans-arabic/latin-400.css';
import '@fontsource/ibm-plex-sans-arabic/latin-600.css';

import './styles/tokens.css';
import './styles/base.css';
import './styles/app.css';

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';

const container = document.getElementById('root');
if (!container) throw new Error('#root is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
